module.exports = __webpack_public_path__ + "static/media/typeb1.aebd0bd8.jpg";